<template>
    <div>
        <CompassButton
            :label="$t.__('common.actions.add_bank_account')"
            class="addBankBtn"
            @click="addAccount"
        />
        <h2 class="mt-0">
            {{ $l10n.__('Informations bancaires de la société') }}
        </h2>

        <bank-table
            :title="$t.__('preferences.Bank.bank_accounts_linked_to_your_account_list')"
            :subtitle="$t.__('preferences.Bank.manage_bank_accounts_linked_to_sellsy')"
            :banks="activateAccount"
            @open="updateForm"
        />

        <bank-table
            v-if="deactivateAccount.length > 0"
            :title="$t.__('preferences.Bank.disabled_bank_accounts_list')"
            :subtitle="$t.__('preferences.Bank.bank_account_not_synchronized_list')"
            :banks="deactivateAccount"
            @open="updateForm"
        />

        <CompassModal
            v-model:visible="dialogVisible"
            size="small"
            :title="$t.__('preferences.Bank.add_account')"
            class="bank-modal"
        >
            <template #default>
                <div class="dialog__default">
                    <p class="gray-60 typographies-paragraph-medium-regular">
                        {{
                            $l10n.__('Sélectionnez le type de compte que vous souhaitez ajouter : ')
                        }}
                    </p>

                    <div class="row gutters mt-1">
                        <div class="col span_6 well acenter">
                            <h4>
                                {{ $l10n.__('Mode synchronisé') }}
                            </h4>
                            <p>
                                {{ $l10n.__('Votre compte est directement connecté à Sellsy.') }}
                                <br />
                                <br />
                                {{
                                    $l10n.__(
                                        'Sélectionnez ce choix si vous souhaitez voir le compte dans le Rapprochement Bancaire.',
                                    )
                                }}
                                <br />
                                <br />
                                <CompassButton
                                    :label="$t.__('common.actions.select')"
                                    :onclick="`BankReconciliation.redirectBudgetInsight();`"
                                />
                            </p>
                        </div>

                        <div class="col span_6 well acenter">
                            <h4>
                                {{ $l10n.__('Mode manuel') }}
                            </h4>
                            <p>
                                {{ $l10n.__('Votre compte est utilisé dans la partie Règlements.')
                                }}<br />
                                <br />
                                {{
                                    $l10n.__(
                                        'Sélectionnez ce choix si vous souhaitez voir le compte dans les règlements et dans les RIB.',
                                    )
                                }}<br />
                                <br />
                                <CompassButton
                                    :label="$t.__('common.actions.select')"
                                    @click="createForm"
                                />
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </CompassModal>

        <bank-form
            v-if="formVisible"
            :bankId="bankToUpdate"
            :defaultBankCode="defaultBankCode"
            :status="statusBankToUpdate"
            :bankCodes="bankCodes"
            @close="closeForm"
        />
    </div>
</template>

<script>
import BankTable from './BankTable.vue';
import BankForm from './BankForm.vue';

export default {
    components: {
        BankTable,
        BankForm,
    },
    props: {
        accounts: {
            type: Array,
            required: true,
        },
        hasBankReconciliation: {
            type: Boolean,
            required: false,
            default: false,
        },
        defaultBankCode: {
            type: Number,
            required: true,
        },
        bankCodes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            dialogVisible: false,
            formVisible: false,
            bankToUpdate: null,
            statusBankToUpdate: null,
        };
    },
    computed: {
        activateAccount: function () {
            return this.accounts.filter((account) => {
                return account.status != 'disconnected' && account.status != 'deleted';
            });
        },
        deactivateAccount: function () {
            return this.accounts.filter((account) => {
                return account.status == 'disconnected' || account.status == 'deleted';
            });
        },
    },
    methods: {
        updateForm(bankAccountId) {
            this.bankToUpdate = parseInt(bankAccountId);
            const bankToUpdate = this.accounts.find((account) => {
                return account.id == bankAccountId;
            });
            this.statusBankToUpdate = bankToUpdate.status;
            this.formVisible = true;
        },
        createForm() {
            this.dialogVisible = false;
            this.formVisible = true;
        },
        addAccount() {
            if (this.hasBankReconciliation) {
                this.dialogVisible = true;
            } else {
                this.createForm();
            }
        },
        closeForm() {
            this.formVisible = false;
            this.bankToUpdate = null;
            this.statusBankToUpdate = null;
        },
    },
};
</script>

<style lang="scss">
.addBankBtn {
    float: right;
}
.bank-modal {
    .dialog {
        &__default {
            padding-bottom: 24px;
            p:first-child {
                margin: 0;
            }
        }
    }
}
</style>
